module.exports = __webpack_public_path__ + "static/media/news-press-c.bf7b1dfe.png";